var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowThin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 8,
    viewBox: "0 0 21 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.146446 4.03519C-0.0488148 3.83993 -0.0488148 3.52335 0.146446 3.32809L3.32843 0.146107C3.52369 -0.0491555 3.84027 -0.0491555 4.03553 0.146107C4.2308 0.341369 4.2308 0.657951 4.03553 0.853214L1.20711 3.68164L4.03553 6.51007C4.2308 6.70533 4.2308 7.02191 4.03553 7.21717C3.84027 7.41244 3.52369 7.41244 3.32843 7.21717L0.146446 4.03519ZM20.5 3.68164V4.18164L0.5 4.18164V3.68164V3.18164L20.5 3.18164V3.68164Z",
    fill: "#626262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowThin);
export default __webpack_public_path__ + "static/media/Arrow-thin.fe117597645a66d7116a31b6da08ff6f.svg";
export { ForwardRef as ReactComponent };